export default __webpack_public_path__ + "static/media/364.fe3b201e.jpg";